import { Directive } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ComponentCanDeactivate } from './component-can-deactivate';

/**
 * Abstract class that will deactivate if the form is dirty. Can be used for route guards.
 * Automatically registers with ComponentRegistryService via base class.
 */
@Directive()
export abstract class FormCanDeactivate extends ComponentCanDeactivate {
  abstract get form(): UntypedFormGroup;

  canDeactivate(): boolean {
    if (this.form) {
      return this.form.disabled || !this.form.dirty;
    } else {
      return true;
    }
  }
}
